<template>
    <svg xmlns="http://www.w3.org/2000/svg"
         :viewBox="viewBox"
         :aria-labelledby="iconName"
         role="presentation"
    >
        <title :id="iconName" lang="en">{{iconName}} icon</title>
        <g>
            <slot />
        </g>
    </svg>
</template>

<script>
export default {
    name: "IconBase",
    props: {
        iconName: {
            type: String,
            default: ''
        },
        viewBox: {
          default: '0 0 1024 1024'
        }

    }
}
</script>

<style scoped>
svg {
    display: inline-block;
    vertical-align: baseline;
}
</style>